import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'retry-button',
    templateUrl: 'retry-button.component.html',
    styleUrls: ['retry-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RetryButtonComponent implements OnInit {

    @Input() buttonTitle: String;
    @Output() notify: EventEmitter<string> = new EventEmitter<string>();

    constructor() {
    }

    restart() {
        this.notify.emit('restart');
    }

    ngOnInit() {
        // this.buttonTitle = 'Start Test';
    }
}
